import { createSlice } from "@reduxjs/toolkit";

interface ModalWindowType {
    isOpen: boolean,
    title: string,
    message: string,
}

const initialState: ModalWindowType = {
    isOpen: false,
    title: '',
    message: '',
}

const modalWindowSlice = createSlice({
    name: 'isOpen',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.isOpen = true;
            state.title = action.payload.title;
            state.message = action.payload.message;
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.title = '';
            state.message = '';
        }
    }
});

export const { openModal, closeModal } = modalWindowSlice.actions;
export default modalWindowSlice.reducer;